import _ from 'lodash'
import VRes from 'vue-resource'
import store from './store'




export default {
  install(Vue) {
    window.Vue = Vue
    Vue.use(VRes)

    Vue.url.options.root = Vue.prototype.$apiurl = store.config.API_URL
    Vue.http.interceptors.push((req, next) => {

      if (store.config.IS_LOCAL) {
        req.url += (req.url.indexOf('?') > 0 ? '&' : '?') + `_ts=${new Date().getTime()}`
        if (req.method.match(/(delete)/i)) {
          req.method = 'POST'
          req.url += (req.url.indexOf('?') > 0 ? '&' : '?') + `_method=DELETE`
        }
      }

      if (store.session) {
        req.headers.append('Authorization', `Bearer ${store.session.token}`)
      }




      // Strip options from url
      var opts = req.url.split('/')[0]
      if (opts && opts[0] === '.') {
        opts = opts.substring(1).split('')
        req.url = req.url.substring(req.url.indexOf('/')+1)
      } else {
        opts = ''
      }
      // console.log('req', req.url, opts)

      // Convert booleans to 0/1 and remove attributes starting with __ and dates to string
      try {
        let rec = (thing, ret) => {
          if (typeof thing != 'object') return
          for (var i in thing) {
            if ((i + '').startsWith('__')) {
              continue
            }
            switch (typeof thing[i]) {
              case 'boolean':
                ret[i] = thing[i] * 1 // make it 0 or 1
                break
              case 'object':
                if (thing[i] === null) {
                  thing[i] = null
                  break
                }
                if (typeof thing[i].toServer == 'function') {
                  ret[i] = thing[i].toServer()
                  break
                }
                ret[i] = {}
                rec(thing[i], ret[i])
                break
              default:
                ret[i] = thing[i]
            }
          }
        }
        if (req && req.body && typeof req.body == 'object' && req.body.constructor.name != 'FormData') {
          var ret = {}
          rec(req.body, ret)
          req.body = ret
        }
      } catch (e) {
        console.log('Could not convert bool req', e, _.clone(req)) // eslint-disable-line no-console
      }

      next(res => {

        if (store.config.IS_LOCAL && res.data && res.data.error && res.data.error.status_code) {
          res.ok = false
          res.status = res.data.error.status_code
        }

        if (!res.ok) {
          if (res.status == 401) {
            Vue.prototype.$error('Sessione scaduta')
            store.session = null
            return // user never handles 401
          } if (res.status == 500) {
            Vue.prototype.$error('Qualcosa è andato storto')
            return // user never handles 500
          } else {
            // If [s]ilent option is not present, then display the error
            if (!opts.includes('s')) {
              Vue.prototype.$error(res)
            }
          }
        }
        return res
      })
    })
  }
}
